import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";

import RootLayout from "./RootLayout";
import RouteError from "./RouteError";
import ProtectedRoute from "./ProtectedRoute";

import QueryTree from './QueryTree';
import './App.css';
import Navbar from './components/Navbar';
// import CreateTablePopup from './CreateTablePopup';
import QueryBuilder from './QueryBuilder';
import CreateNewConnectionPage from './pages/CreateNewConnectionPage';
import ListConnectionPage from './pages/ListConnectionPage';
import EditConnectionPage from './pages/EditConnectionPage';
import ListOfFiles from './pages/ListOfFiles';
import Login from './pages/Login';
import FunctionsPage from './pages/FunctionsPage';
import QueryEditorPage from './pages/QueryEditor';
import ApplyFunctionsPage from './pages/ApplyFunctions';
import { loadStripe } from "@stripe/stripe-js";
import UserManagement from './pages/UserManagement';
import ManageBuilds from './pages/Builds';
import { AuthProvider } from "./pages/AuthContext";
import ErrorBoundary from "./pages/ErrorBoundaryPage"
import Documents from "./pages/Documentation"
import Privacy from "./pages/Privacy";
import ServiceTerms from "./pages/ServiceTerms";
import Impressum from "./pages/Impressum";
import Contact from "./pages/Contact";
import BillingPage from "./pages/BillingPage";
import ContactForm from "./pages/ContactForm";
import Pricing from "./pages/Pricing"

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
  console.debug = () => {};
}

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Elements stripe={stripePromise}>
        <RootLayout />
      </Elements>
    ),
    errorElement: <RouteError />, //GLOBAL ERROR HANDLER
    children: [
      { index: true, element: <Login /> },
      { path: "docs", element: <Documents /> },
      { path: "privacy", element: <Privacy /> },
      { path: "terms", element: <ServiceTerms /> },
      { path: "impressum", element: <Impressum /> },
      { path: "contact", element: <Contact /> },
      { path: "billing", element: <BillingPage /> },
      { path: "contactForm", element: <ContactForm /> },
      { path: "pricing", element: <Pricing /> },
    {
    element: <ProtectedRoute />,
    children: [
      //{ index: true, element: <Login /> },
      { path: "listConnectionPage", element: <ListConnectionPage /> },
      { path: "querytree", element: <QueryTree /> },
      { path: "QueryBuilder", element: <QueryBuilder /> },
      { path: "CreateNew", element: <CreateNewConnectionPage /> },
      { path: "EditConn", element: <EditConnectionPage /> },
      { path: "queryEditor", element: <QueryEditorPage /> },
      { path: "applyFunctions", element: <ApplyFunctionsPage /> },
      { path: "listOfFiles", element: <ListOfFiles /> },
      { path: "functions", element: <FunctionsPage /> },
      { path: "users", element: <UserManagement /> },
      { path: "builds", element: <ManageBuilds /> },
      // continue your routes...
    ],
  },
 ],
  },
]);

function App() {
  return (
    <ErrorBoundary>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
